import { createApp } from 'vue'
import App from './App.vue'

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/app.css';

createApp(App).mount('#app')
